import api from './api.service';

export interface ContainerMetric {
  container_id: string;
  container_name: string;
  timestamp: number;
  cpu_usage_percent?: number;
  cpu_usage_nanocores?: number;
  memory_usage_percent?: number;
  memory_used_bytes?: number;
  memory_limit_bytes?: number;
  memory_working_set_bytes?: number;
  network_rx_bytes?: number;
  network_tx_bytes?: number;
  network_rx_packets?: number;
  network_tx_packets?: number;
  block_io_read_bytes?: number;
  block_io_write_bytes?: number;
  status?: string;
  restart_count?: number;
}

export interface TimeSeriesData {
  timestamp: number;
  time: string;
  value: number;
}

const kubernetesMetricApi = {
  // Get all containers
  getContainers: async () => {
    const response = await api.get('/v1/kubernetes/containers');
    return response;
  },

  // Get current metrics for a container
  getCurrent: async (containerId: string) => {
    const response = await api.get(`/v1/kubernetes/containers/${containerId}/metrics/current`);
    return response;
  },

  // Get time series for a specific metric
  getTimeSeries: async (
    containerId: string,
    metricName: string,
    startTime: number,
    endTime: number
  ) => {
    const response = await api.get('/v1/kubernetes/containers/metrics/timeseries', {
      params: {
        containerId,
        metricName,
        startTime,
        endTime,
      },
    });
    return response;
  },
};

export default kubernetesMetricApi;
